import { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { useTheme } from 'styled-components';

import { AppContext } from '../../../context/AppContext';
import { useRedirectIfNoTariffs } from '../../../hooks';
import { compareAndGetCurrentTariff } from '../../../utils/tariffComparisonUtils';

import { AlternativeTariffs, FAQs, RecommendedTariff, YourCurrentTariff } from './Recommended';

const RecommendedContainer = () => {
  const { recommendedTariffs, tariffSimResponseGeneratedDate, userDetails } = useContext(AppContext);
  const theme = useTheme();

  useRedirectIfNoTariffs();

  // Use tariff comparison utility to determine if user has recently switched
  const { hasTariffBeenRecentlyUpdated } = compareAndGetCurrentTariff(userDetails, recommendedTariffs);

  return (
    <>
      {!!recommendedTariffs && userDetails && (
        <div className="pt-4">
          <YourCurrentTariff recommendedTariffs={recommendedTariffs} />

          {/* Only show the analysis text if user hasn't recently updated their tariff */}
          {!hasTariffBeenRecentlyUpdated ? (
            <p className="mt-3">{theme.language.appName} has analysed your usage to suggest better tariffs for you:</p>
          ) : (
            <div className="mt-4" />
          )}

          <RecommendedTariff
            recommendedTariffs={recommendedTariffs}
            hasTariffBeenRecentlyUpdated={hasTariffBeenRecentlyUpdated}
          />

          {recommendedTariffs?.length > 1 && (
            <>
              {!!tariffSimResponseGeneratedDate && (
                <p className="mt-3 text-muted">Alternative tariffs - generated on {tariffSimResponseGeneratedDate}</p>
              )}
              <AlternativeTariffs recommendedTariffs={recommendedTariffs} />
            </>
          )}
          <FAQs />
          <Button onClick={() => (window.location.href = theme.links.howDoISwitch)} className="w-100">
            How do I switch?
          </Button>
        </div>
      )}
    </>
  );
};

export default RecommendedContainer;
